module.exports = __webpack_public_path__ + "static/media/mil52item.793f7ce0.png";